import { IAddUpdateDeleteObject } from 'constants/interfaces/GlobalInterfaces';
import { SortOrder } from 'antd/lib/table/interface';
import { IContactItem } from './interface';

export interface IGlobalContactsReducerStore {
  loading: boolean;
  page: number;
  contacts: IContactItem[];
  totalContacts: number;
  newContactAdded: boolean;
  // search scenario
  searchTerm: string;
  searchLoading: boolean;
  searchedPage: number;
  searchedContacts: IContactItem[];
  totalSearchedContacts: number;
  totalContactsNotInList: number;
  totalSearchedContactsNotInList: number;
  fromWorkFlow: boolean;
  // add new|update|delete contact scenario
  addNewContacts: IAddUpdateDeleteObject;
  deleteContacts: IAddUpdateDeleteObject;
  updateContacts: IAddUpdateDeleteObject;
  addToListContacts: IAddUpdateDeleteObject;
  addToListGlobalMode: boolean;
  // recently added contacts
  recentlyAddedContacts: IContactItem[];
  // open edit contact sidebar
  openEditContactSidebar: boolean;
  currentActiveList: string;
  isGlobalContactsSelected: boolean;
  isSorted: boolean;
}

export interface IGlobalContactsReducerAction {
  type: string;
  payload: { [key: number | string]: string | number | boolean | IContactItem | IContactItem[] | number[] | string[] };
}

export interface IGetGlobalContactsParams {
  limit: number;
  offset: number;
  search_by_name: string;
  filter_by_organization: string[];
  filter_by_designation: string[];
  filter_by_personality_type: string[];
  filter_by_status: string[];
  sort_by?: string;
  sort_type?: string;
  export?: boolean;
  email_id?: string;
  list_id?: string;
  uuid?: string;
  event_type?: string;
}

export interface IGetGlobalContactsResponseData {
  contacts: IContactItem[];
  totalContacts: number;
  totalContactsWithoutList: number;
  listName?: string;
}

export interface IGetGlobalContactsResponse {
  data: IGetGlobalContactsResponseData[];
  success: boolean;
  message: string;
}

export interface IDeleteGlobalContactsParams {
  contactIds: number[];
  deleteAll: boolean;
  excludedContactIds: number[];
  listId?: string | number;
  excludeListId?: string;
  searchTerm?: string;
  selectedOrganization?: string[];
  selectedDesignation?: string[];
  selectedPersonalityType?: string[];
  selectedStatus?: string[];
}

export interface IDeleteGlobalContactsResponse {
  success: boolean;
  message: string;
}

//* *******************************
//* ***** Contacts Filters  *******
//* *******************************

export interface IContactFilterObjectState {
  loading: boolean;
  data: string[];
  searchedLoading: boolean;
  searchedData: string[];
  searchTerm?: string;
}

export interface IAppliedContactsFilters {
  designation: string[];
  organization: string[];
  personalityType: string[];
  status: string[];
}

export interface IContactsFiltersObject {
  designations: IContactFilterObjectState;
  organizations: IContactFilterObjectState;
  // personalityTypes: IContactFilterObjectState;
  // statuses: IContactFilterObjectState;
  selectedFilters: IAppliedContactsFilters;
  appliedFilters: IAppliedContactsFilters;
}
export interface IContactsFiltersListData {
  listId: number | string;
}
export interface IContactsFiltersReducerStore {
  globalContactsFilters: IContactsFiltersObject;
  listContactsFilters: IContactsFiltersObject & IContactsFiltersListData;
}
export interface IContactsFiltersReducerAction {
  type: string;
  payload: { [key: number | string]: string | number | boolean | string[] };
}

export interface IContactsFiltersResponse {
  data: [{ [key: string]: string[] }];
  success: boolean;
  message: string;
}

export interface ISortConfig {
  sortBy: string;
  sortType: string;
}

export interface ISortOrder {
  name: SortOrder;
  company: SortOrder;
  personality: SortOrder;
  status: SortOrder;
  // engagement: SortOrder;
  createdOn: SortOrder,
}

export enum ContactsFiltersEnum {
  Designations = 'designations',
  Organizations = 'organizations',
  PersonalityType = 'personalityType',
  Status = 'status',
}
